import styled from '@emotion/styled';

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 33px 1fr;
  margin-left: 0;
`;

export const ToggleButton = styled.span`
  font-size: 23px;
  color: #6b6b6b;
  line-height: 37px;
  text-align: left;
  cursor: pointer;
`;

export const RevealContainer = styled.div<{ isExpanded: boolean }>`
  height: ${(props) => (props.isExpanded ? '160px' : '0')};
  overflow: hidden;
  transition-property: height;
  transition-duration: 150ms;
  transition-timing-function: ease-in;
`;
